import { Routes } from '@angular/router';
import { CalGuardService } from '@cvx/cal-angular';
import { BusinessDomainDetailsComponent } from './business-domain-details/business-domain-details.component';
import { BdCreationComponent } from './business-domain/bd-creation/bd-creation.component';
import { BusinessDomainsComponent } from './business-domain/business-domains/business-domains.component';
import { ListBusinessDomainsComponent } from './business-domain/list-business-domains/list-business-domains.component';
import { ConnectionsComponent } from './connection-automation/connections/connections.component';
import { CreateConnectionComponent } from './connection-automation/create-connection-component/create-connection.component';
import { ListConnectionsComponent } from './connection-automation/list-connections-component/list-connections.component';
import { ListDatasetsComponent } from './datasets/list-datasets/list-datasets.component';
import { HelpComponent } from './help/help.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/business-domains',
        pathMatch: 'full',
    },
    {
        path: 'business-domains',
        component: BusinessDomainsComponent,
        canActivate: [CalGuardService],
        children: [
            {
                path: '',
                component: ListBusinessDomainsComponent,
                canActivate: [CalGuardService],
            },
            {
                path: 'create',
                component: BdCreationComponent,
                canActivate: [CalGuardService],
            },
        ],
    },
    {
        path: 'connections',
        component: ConnectionsComponent,
        canActivate: [CalGuardService],
        children: [
            {
                path: '',
                component: ListConnectionsComponent,
                canActivate: [CalGuardService],
            },
            {
                path: 'create',
                component: CreateConnectionComponent,
                canActivate: [CalGuardService],
            },
        ],
    },
    {
        path: 'business-domain-details/:id',
        component: BusinessDomainDetailsComponent,
        canActivate: [CalGuardService],
    },
    {
        path: 'datasets',
        component: ListDatasetsComponent,
        canActivate: [CalGuardService],
    },
    {
        path: 'help',
        component: HelpComponent,
    },
];
